import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { Grid, Col } from '@koaly/grid';
import { marginBottomSpacing, rem } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { useLinkWrapper } from '../../hooks/useLinkWrapper.js';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../Button/ButtonGroup/ButtonGroup.js';
import { DrawerWithToggle } from '../Drawer/DrawerWithToggle/DrawerWithToggle.js';
import { Logo } from '../Logo/Logo.js';
import { MobileDrawerNavigation } from '../MobileDrawerNavigation/MobileDrawerNavigation.js';
import { Navigation } from '../Navigation/Navigation.js';
import { NavigationItem } from '../Navigation/NavigationItem.js';
import { ObjectFit } from '../ObjectFit/ObjectFit.js';

const StyledTopBar = styled.header `
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
`;
const StyledGrid = styled(Grid) `
  height: ${rem(104)};

  ${down('xs')} {
    height: ${rem(74)};
  }
`;
styled(Button) `
  position: absolute;
  right: ${rem(20)};
  top: ${rem(25)};
`;
const StyledLogoCol = styled(Col) `
  height: 100%;
`;
const StyledLink = styled.a `
  width: 100%;
  height: 100%;
`;
const StyledNavCol = styled(Col) `
  width: max-content;
`;
const TopBar = withExtra(({ links, buttons, variant, logoLink, spaceAfter, logo, navigationAppearance, openMenuButtonLabel, closeMenuButtonLabel, showButtonsOnMobile, }) => {
    const linkWrap = useLinkWrapper();
    return (React.createElement(StyledTopBar, { variant: variant, spaceAfter: spaceAfter },
        React.createElement(StyledGrid, null,
            React.createElement(StyledLogoCol, { flex: true, width: { xs: 130, m: 3 / 12 }, valign: "center", halign: "left" },
                logoLink &&
                    linkWrap(React.createElement(StyledLink, { href: logoLink.href, "aria-label": "Terug naar home", onClick: logoLink.onClick },
                        React.createElement(ObjectFit, { fit: "contain", objectPosition: "0% 50%", width: null }, !logo ? React.createElement(Logo, null) : logo))),
                !logoLink && (React.createElement(ObjectFit, { fit: "contain", objectPosition: "0% 50%", width: null }, !logo ? React.createElement(Logo, null) : logo))),
            React.createElement(StyledNavCol, { flex: true, halign: "center", valign: "center", visible: { xs: false, s: true } },
                React.createElement(Navigation, { spacing: 20, direction: "horizontal" }, links &&
                    links.map((item, i) => linkWrap(React.createElement(NavigationItem, { appearance: navigationAppearance, variant: variant, href: item.href, key: i + '-link-top-bar' }, item.label))))),
            React.createElement(Col, { flex: true, width: { xs: 'stretch', m: 3 / 12 }, halign: "right", valign: "center", visible: { xs: false, s: true } }, buttons && (React.createElement(ButtonGroup, { spacing: 4 }, buttons.map((_a, i) => {
                var { label, size } = _a, rest = __rest(_a, ["label", "size"]);
                return linkWrap(React.createElement(Button, Object.assign({ key: i + '-button-topbar' }, rest, { elevation: 1, size: size || 'small' }), label));
            })))),
            React.createElement(Col, { width: "stretch", halign: "right", valign: "center", visible: { xs: true, s: false } },
                React.createElement(ButtonGroup, { spacing: 4 },
                    showButtonsOnMobile && buttons.map((_a, i) => {
                        var { label, size } = _a, rest = __rest(_a, ["label", "size"]);
                        return linkWrap(React.createElement(Button, Object.assign({ key: i + '-button-topbar' }, rest, { elevation: 1, iconOnly: true, size: size || 'small' }), label));
                    }),
                    React.createElement(DrawerWithToggle, { width: "100%", position: "right", button: React.createElement(Button, { type: "button", size: "small", variant: "basic" }, openMenuButtonLabel) },
                        React.createElement(MobileDrawerNavigation, { links: links })))))));
}, { name: 'TopBar' });
TopBar.defaultProps = {
    variant: 'primary',
    openMenuButtonLabel: 'Menu',
    closeMenuButtonLabel: 'Sluiten',
    showButtonsOnMobile: false,
};

export { TopBar };
//# sourceMappingURL=TopBar.js.map
